import clientHttp from '../tools/clientHttp'
import UserProfile from "../data";
const user = UserProfile.getUserData();
const URL = "/inventories/zone";
let inventoryZones = [];
let langDate = "es";

export const getInventoryZones = async () => {
    return clientHttp.get(`${URL}`)
}

export const getInventoryZonesItems = async () => {
    const zones = await getZones();
    return zones.map(zone => ({
        value: zone.id,
        text: zone.name.toUpperCase(),
    }));
}

export const loadInventoryZones = async () => {
    const zones = await getInventoryZones();
    inventoryZones = zones.data.map(zone => ({
        id: zone.id,
        name: zone.name.toUpperCase(),
        description: zone.description,
        active: zone.active,
    }));
    return inventoryZones;
}

export const createInventoryZone = async (zone) => {
    return clientHttp.post(`${URL}`, zone)
}

export const updateInventoryZone = async (zone) => {
    return clientHttp.put(`${URL}/${zone.id}`, zone)
}

export const deleteInventoryZone = async (id) => {
    return clientHttp.delete(`${URL}/${id}`)
}

const getZones = async () => {
   //return (await getInventoryZones()).data;
   return user?.level === 'admin' ? (await getInventoryZones()).data : [user.zone] || (await getInventoryZones()).data;
}